import { howItWorksSteps } from '@/mocks/articles';

export default function HowItWorksSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-flex items-center px-4 py-1.5 rounded-full border border-accent-300 bg-accent-100/60 text-xs font-semibold text-accent-800 uppercase tracking-wide mb-4">
            The Process
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-foreground-950 leading-tight tracking-tight">
            How VigorBuy<br />Works
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            From product discovery to doorstep delivery, the streamlined buying process that thousands trust.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {howItWorksSteps.map((step, index) => (
            <div
              key={step.step}
              className="group relative rounded-xl p-5 md:p-6 bg-background-50 border border-background-200/70 hover:bg-accent-100/80 hover:border-accent-300 transition-all duration-300 cursor-default"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <span className="text-sm font-bold">{step.step}</span>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-950 mb-2 group-hover:text-accent-700 transition-colors">
                {step.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {step.description}
              </p>

              {index < howItWorksSteps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-2.5 transform -translate-y-1/2 z-10">
                  <span className="w-6 h-6 flex items-center justify-center text-foreground-300">
                    <i className="ri-arrow-right-s-line" />
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}